import APIClient from '@/shared/http/clients/api'

const resourceName = 'APRTemplateEpi'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetAPRTemplateEPIGrid = (limit, index, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetAPRTemplateEPIGrid?limit=${limit}&index=${index}`, data, config)
const postNewEPI = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/newEPIByTemplate`, data, config)
const ExcluirEPI = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/ExcluirEPI`, data, config)

const APRTemplateEpiRepository = {
  GetAPRTemplateEPIGrid,
  postNewEPI,
  ExcluirEPI
}

export default APRTemplateEpiRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/aprTemplateEpi.js